import React, { Component } from 'react'
import { colorTertiaryForPrint } from '../../Utils'

export class LookAndFeelLabial extends Component {

  render() {
    const { state, location } = this.props

    let rgba = colorTertiaryForPrint(location, state)
    

    return (
      <div data-test="LookAndFeelLabialComponent" style={{ background: rgba}}>
          <img src="http://yoo.devletec.com/wp-content/themes/svhen/dist/images/mockup_wizardtransparaente.png" alt="Labial Demo" className="img-fluid d-none d-md-block"/>
          <img src="http://yoo.devletec.com/wp-content/themes/svhen/dist/images/mockup-color-mobile.png" alt="Labial Demo" className="img-fluid d-md-none"/>

      </div>
    )
  }
}

export default LookAndFeelLabial
